module.exports = __webpack_public_path__ + "img/brand_logo_ram.deec68aa.png";